import videojs, {videoJsControlsBar} from './lib/videojs'
import {findKey, map} from 'lodash'

const Plugin = videojs.getPlugin('plugin')

// Values for plugin
const Event = {}
const Selector = {
    MAIN: '#course',
    HEADER: '#player-header',
    HEADER_PREV: '.prev',
    HEADER_NEXT: '.next',
    HEADER_CHAPTER_INDEX: '.chapter-index',
    HEADER_EPISODE_INDEX: '.chapter-lesson-index',
    STATUS: '#course-progress',
    STATUS_PERCENT: '.progress-percent',
    STATUS_BAR: '.progress-bar',
    STATUS_LESSONS_LEFT: '.progress-lessons-left',
    STATUS_LESSONS_DONE: '.progress-lessons-done',
    STATUS_CIRCLE: '.circle-progress',
    COMPLETER: '#completer-controller',
    COMPLETER_LESSON: 'input[name=lesson_id]',
    COMPLETER_ACTION: 'input[name=action]',
    COMPLETER_COMPLETE: '.mark-complete',
    COMPLETER_UNCOMPLETE: '.mark-uncomplete',
    SERIE: '#episode-controller',
    SERIE_CHAPTER: '.chapter-heading',
    SERIE_CHAPTER_EPISODES: '.chapter-lessons',
    SERIE_EPISODE: 'span.lesson',
    SERIE_EPISODE_PROGRESS: '.progress',
    // DISCUSSIONS_PANEL: '#discussions-panel'
}
const ClassName = {
    HIDE: 'd-none',
}
const Status = {
    COMPLETED: 'completed',
    PLAYED: 'played',
    NOT_PLAYED: 'not_played',
}
const Defaults = {
    className: 'comando-enabled',
    tracker: null,
    delay: 10, // seconds (video tracking min. delay)
    lesson: null, // id of a starting lesson
    videoType: 'video/mp4',
    videoQuality: 'sd',
    videoQualities: {hd: '1080P', sd: '720P', ld: '480P'},
    lang: {
        next: 'Prossimo',
        prev: 'Precedente',
        cancel: 'Annulla'
    }
}
const Patterns = {
    lesson: lessonId => $(`#lesson-${lessonId}`)
}

/**
 * An advanced Video.js plugin
 */
class Comando extends Plugin {
    /**
     * Create a Comando plugin instance.
     *
     * @param  {Player} player
     *         A Video.js Player instance.
     *
     * @param  {Object} [options]
     *         An optional options object.
     */
    constructor(player, options) {
        // the parent class will add player under this.player
        super(player)
        this.options = videojs.mergeOptions(Defaults, $(Selector.MAIN).data(), options)
        this.episodes = []
        this.nextUpdate = undefined
        this.lastUpdateAt = 0
        // this.on('statechanged', this.handleStateChanged);
        this.init()
    }

    init() {
        const plugin = this;
        plugin.$header = $(Selector.HEADER)
        plugin.$status = $(Selector.STATUS)
        plugin.$completer = $(Selector.COMPLETER)

        // initialize chapters and episodes
        plugin.$serie = $(Selector.SERIE)
        plugin.$chapters = plugin.$serie.find(Selector.SERIE_CHAPTER)
        plugin.$episodes = plugin.$serie.find(Selector.SERIE_EPISODE)

        plugin.isPlaying = false;
        plugin.player.on(['waiting', 'pause'], function () {
            plugin.isPlaying = false;
        })
        plugin.player.on('playing', function () {
            plugin.isPlaying = true;
        })

        plugin.player.ready(() => {
            plugin.player.addClass(plugin.options.className)

            // enable hotkeys
            plugin.player.hotkeys({
                volumeStep: 0.1,
                seekStep: 5,
                enableModifiersForNumbers: false
            });

            plugin.player.on('ended', (event) => {
                console.log('player.ended', event, this)
                this.handleCompleted(true)
            })

            // handle episodes links
            plugin.$serie.on('click', Selector.SERIE_EPISODE, e => {
                e.preventDefault()
                plugin.setEpisode(e.target)
            })

            // handle header prev/next buttons
            plugin.$header
                .on('click', Selector.HEADER_PREV, e => {
                    e.preventDefault()
                    plugin.goToPrevEpisode()
                })
                .on('click', Selector.HEADER_NEXT, e => {
                    e.preventDefault()
                    plugin.goToNextEpisode()
                })

            // handle completer
            plugin.$completer.on('submit', e => {
                e.preventDefault()
                const $form = $(e.target)
                const $icon = $form.find('i').addClass('fa-spin')
                plugin.isPlaying && plugin.player.pause()
                $.post($form.attr('action'), $form.serialize()).done(response => {
                    // TODO: maybe we have to pass the completed/uncompleted episode
                    this.handleCompleted(response.progress === 100)
                    // this.toggleComplete(undefined, response.progress == 100)
                }).always(response => {
                    $icon.removeClass('fa-spin')
                })
            })

            // load initial episode
            this.setEpisode(Patterns.lesson(this.options.lesson), false)

            plugin.player.on('qualitySelected', function (event, newSource) {
                const quality = findKey(plugin.options.videoQualities, q => q === newSource.label)
                plugin.setQuality(quality)
            })
            plugin.player.on('ratechange', function () {
                plugin.setRate(plugin.player.playbackRate())
            });
            plugin.player.on('volumechange', function () {
                plugin.setVolume(plugin.player.volume())
            })
        })
    }

    handleStateChanged(event) {
        this.log('state', event)
        const changes = event.changes

        if (changes.chapter) {
            // update header
            this.$header.find(Selector.HEADER_CHAPTER_INDEX).text(changes.chapter.to + 1)
        }
        if (changes.episode) {
            const toEpisode = this.getEpisode(changes.episode.to)
            const episodeStatus = this.getEpisodeStatus(toEpisode)
            const prevEpisode = this.getPrevEpisode(changes.episode.to)
            const nextEpisode = this.getNextEpisode(changes.episode.to)

            // update header
            this.$header.find(Selector.HEADER_EPISODE_INDEX).text(
                this.getChapterEpisodes(this.state.chapter).index(toEpisode) + 1
            )
            // update header controllers
            this.$header.find(Selector.HEADER_PREV)
                .toggleClass('disabled', !prevEpisode)
                .attr('href', prevEpisode ? prevEpisode.attr('href') : '#')
            this.$header.find(Selector.HEADER_NEXT)
                .toggleClass('disabled', !nextEpisode)
                .attr('href', nextEpisode ? nextEpisode.attr('href') : '#')

            // update old episode
            if (!isNaN(changes.episode.from)) {
                const fromEpisode = this.getEpisode(changes.episode.from)
                // update episode classes and icons
                fromEpisode.addClass('played').removeClass('playing')
                // update resume from
                fromEpisode.data('resumeFrom', fromEpisode.data('progress') != 100 ? this.player.currentTime() : 0)
            }
            toEpisode.removeClass('played').addClass('playing')
            // update completer
            this.setCompleter(Status.COMPLETED == episodeStatus, toEpisode.data('lesson'))
            // reset waiter
            this.nextUpdate = undefined
            // reset delayer
            this.lastUpdateAt = 0
            // update discussions panel
            // $(Selector.DISCUSSIONS_PANEL).data('loaded', false)
            // $(Selector.DISCUSSIONS_PANEL).data('url',
            //     $(Selector.DISCUSSIONS_PANEL).data('url').replace(/(lesson_id=)[^\&]+/, '$1' + toEpisode.data('lesson'))
            // )
        } else if (changes.episode_progress) {
            const episode = this.getEpisode()
            episode.data('progress', changes.episode_progress.to)
            episode.next(Selector.SERIE_EPISODE_PROGRESS).find(Selector.STATUS_BAR).attr('aria-valuenow', changes.episode_progress.to).css('width', changes.episode_progress.to + '%')
            this.updateProgressCall(
                episode.data('lesson'),
                changes.episode_progress.to,
                this.player.currentTime()
            )
            // $.post(this.options.tracker, {
            //     progress: changes.episode_progress.to,
            //     lesson_id: episode.data('lesson'),
            //     time: this.player.currentTime()
            // }).done(response => {
            //     this.nextUpdate = undefined
            //     this.lastUpdateAt = 0
            //     this.handleProgressUpdated(response)
            // })
        }
        if (changes.progress) {
            const percent = `${this.state.progress}%`
            this.$status.find(Selector.STATUS_PERCENT).text(percent)
            this.$status.find(Selector.STATUS_BAR).attr('aria-valuenow', this.state.progress).css('width', percent)
            this.$status.find(Selector.STATUS_CIRCLE).circleProgress({value: this.state.progress / 100})
            const episodesDone = this.$episodes.filter((_, episode) => $(episode).hasClass(Status.COMPLETED)).length
            this.$status.find(Selector.STATUS_LESSONS_DONE).text(episodesDone)
            this.$status.find(Selector.STATUS_LESSONS_LEFT).text(this.$episodes.length - episodesDone)
        }
    }

    updateProgressCall(lessonId, progress, time, force = false) {
        time = Math.ceil(time)
        const toBeDelayed = ((new Date()).getTime() - this.lastUpdateAt) < (this.options.delay * 1000)
        console.log('updateProgressCall',
            (new Date()).getTime(),
            (new Date()).getTime() - this.lastUpdateAt,
            this.options.delay * 1000,
            toBeDelayed,
            this.nextUpdate)
        if (toBeDelayed && ! force) {
            return
        }
        if (this.nextUpdate && ! force) {
            this.nextUpdate = [lessonId, progress, time]
        } else {
            this.lastUpdateAt = (new Date()).getTime()
            // remove this: this.player.pause()
            $.post(this.options.tracker, {
                progress: progress,
                lesson_id: lessonId,
                time: time
            }).done(this.handleProgressUpdated.bind(this))
        }
    }

    handleProgressUpdated(response) {
        this.log('handleProgressUpdated', response)
        if (this.nextUpdate) {
            var params = this.nextUpdate
            this.nextUpdate = undefined
            this.updateProgressCall(params[0], params[1], params[2])
        }
    }

    handleTimeUpdate(event) {
        const duration = this.player.duration()
        if (isNaN(duration)) {
            return
        }
        const currentTime = this.player.currentTime()
        const currentProgress = parseInt((currentTime / duration) * 100, 10)
        if (this.state.episode_progress < currentProgress) {
            this.setState($.extend({}, this.state, {
                episode_progress: currentProgress
            }))
        }
    }

    handleCompleted(isCompleted) {
        const episode = this.getEpisode()
        episode.toggleClass('completed', !!isCompleted).data('progress', isCompleted ? 100 : 0)
        this.setCompleter(isCompleted)
        this.state.episode_progress = isCompleted ? 100 : 0
        this.setState($.extend({}, this.state, {
            progress: this.calculateProgress()
        }))
        if (isCompleted) {
            this.updateProgressCall(
                episode.data('lesson'),
                100,
                this.player.duration(),
                true
            )
        }
    }

    calculateProgress() {
        const progressList = this.$episodes.map((ix, episode) => parseInt($(episode).data('progress'), 10)).toArray()
        return parseInt(progressList.reduce((a, b) => a + b, 0) / this.$episodes.length, 10)
    }

    setCompleter(isCompleted, lessonId) {
        this.$completer.find(Selector.COMPLETER_ACTION).switchValue(isCompleted ? 'reset' : 'complete');
        this.$completer.find(Selector.COMPLETER_COMPLETE).toggleClass(ClassName.HIDE, !!isCompleted)
        this.$completer.find(Selector.COMPLETER_UNCOMPLETE).toggleClass(ClassName.HIDE, !isCompleted)
        if (typeof lessonId !== "undefined") {
            this.$completer.find(Selector.COMPLETER_LESSON).val(lessonId)
        }
    }

    setEpisode(index, andPlay = true) {
        this.log('setEpisode', index)
        if (isNaN(index)) {
            // should be a Episode element
            index = this.getEpisodeIndex(index)
        }

        const episodeConfig = this.getEpisode(index).data()
        // change source/poster in the player
        this.player.poster(episodeConfig.poster || '')
        this.player.src($.map(episodeConfig.sources || [], (source, quality) => ({
            type: this.options.videoType,
            src: source,
            label: this.options.videoQualities[quality],
            selected: quality === this.getQuality()
        })))

        // update the state with new episode
        this.setState($.extend({}, this.state, {
            chapter: this.getEpisodeChapterIndex(index),
            episode: index,
            episode_progress: episodeConfig.progress
        }))

        // after changing source we need to re-add the handler form timeupdate
        this.on(this.player, ['timeupdate'], this.handleTimeUpdate);

        // setup upnext for next episode
        const nextEpisode = this.getNextEpisode()
        if (nextEpisode) {
            this.player.upnext({
                timeout: 5000,
                headText: this.options.lang.next,
                cancelText: this.options.lang.cancel,
                getTitle: () => (nextEpisode.attr('title')),
                next: () => (this.setEpisode(nextEpisode))
            })
        } else {
            // TODO: handle course finish!
        }

        this.player.defaultPlaybackRate(this.getRate())
        this.player.volume(this.getVolume())
        this.player.one('loadedmetadata', function() {
            if ((typeof episodeConfig.resumeFrom !== 'undefined') && episodeConfig.resumeFrom > 0) {
                console.log('set-start-time', episodeConfig.resumeFrom)
                console.log('lesson duration', this.duration())
                if(episodeConfig.resumeFrom < this.duration()) {
                    this.currentTime(episodeConfig.resumeFrom)
                }
            }
        });

        // then auto-play
        andPlay && this.player.play()
    }

    goToPrevEpisode(index) {
        this.setEpisode(this.getPrevEpisode(index))
    }

    goToNextEpisode(index) {
        this.setEpisode(this.getNextEpisode(index))
    }

    getEpisode(index) {
        if (!isNaN(index) && (index < 0 || index > this.getLastEpisodeIndex())) {
            return
        }
        return $(this.$episodes.get(!isNaN(index) ? index : this.state.episode))
    }

    getEpisodeIndex(element) {
        return this.$episodes.index(element)
    }

    getNextEpisode(index) {
        return this.getEpisode((!isNaN(index) ? index : this.state.episode) + 1)
    }

    getPrevEpisode(index) {
        return this.getEpisode((!isNaN(index) ? index : this.state.episode) - 1)
    }

    getLastEpisodeIndex() {
        return this.$episodes.length - 1
    }

    getEpisodeChapter(episodeIndex) {
        return $(this.getEpisode(!isNaN(episodeIndex) ? episodeIndex : this.state.episode).closest('.chapter-lessons').prev(Selector.SERIE_CHAPTER))
    }

    getEpisodeChapterIndex(episodeIndex) {
        return this.$chapters.index(this.getEpisodeChapter(!isNaN(episodeIndex) ? episodeIndex : this.state.episode))
    }

    getChapterEpisodes(index) {
        return $(this.$chapters.get(!isNaN(index) ? index : this.state.chapter)).next(Selector.SERIE_CHAPTER_EPISODES).find(Selector.SERIE_EPISODE)
    }

    getEpisodeStatus(episode) {
        episode = isNaN(episode) ? episode : this.getEpisode(episode)
        const progress = parseInt(episode.data('progress'), 10)
        if (progress == 100) {
            return Status.COMPLETED
        } else if (progress == 0) {
            return Status.NOT_PLAYED
        } else {
            return Status.PLAYED
        }
    }

    getQuality() {
        return Cookies.get('player-quality') || this.options.videoQuality
    }

    setQuality(quality) {
        if (quality !== this.getQuality()) {
            console.log('set-quality', quality)
            Cookies.set('player-quality', quality)
        }
    }

    getRate() {
        return Cookies.get('player-rate') || 1.0
    }

    setRate(rate) {
        if (rate !== this.getRate()) {
            console.log('set-rate', rate)
            Cookies.set('player-rate', rate)
        }
    }

    getVolume() {
        return Cookies.get('player-volume') || 1.0
    }

    setVolume(volume) {
        if (volume !== this.getVolume()) {
            console.log('set-volume', volume)
            Cookies.set('player-volume', volume)
        }
    }

    isPlaying(episode) {
        const index = isNaN(episode) ? this.getEpisodeIndex(episode) : episode
        return index == this.state.episode
    }

    progressToTime(progress) {
        return parseInt((this.player.duration() / progress) * 100, 10)
    }

    timeToProgress(time) {
        return parseInt((time / this.player.duration()) * 100, 10)
    }

    log(action, options) {
        this.player.log('COMANDO', action, options)
    }
}

Comando.defaultState = {
    progress: undefined,
    chapter: undefined,
    episode: undefined,
    episode_progress: undefined,
    last_update_at: 0
}

videojs.registerPlugin('comando', Comando)


class SimpleComando extends Plugin {
    constructor(player, options) {
        super(player)
        this.options = videojs.mergeOptions(Defaults, $(Selector.MAIN).data(), options)
        this.init()
    }

    init() {
        const plugin = this
        plugin.$episodes = $('.lesson.playable[data-lesson]')
        plugin.$episodes.on('click', e => {
            e.preventDefault()

            if (!$(e.target).data('modal')) {
                plugin.startLesson(e)
                return
            }

            if (!Cookies.get('first-free-lesson')) {
                Cookies.set('first-free-lesson', true)
                plugin.startLesson(e);
                return;
            }

            if (Cookies.get('leadgen-modal-completed')) {
                plugin.startLesson(e)
                return
            }

            plugin.player.pause()

            var modal_corso = $('#corso-leadgen-modal')

            if (modal_corso.length) {
                let leadgenModal = new Modal(modal_corso)
                leadgenModal.show()

                return;
            }

            plugin.startLesson(e)
        })
        plugin.on(plugin.player, ['timeupdate'], plugin.handleTimeUpdate);
        plugin.on(plugin.player, ['play'], plugin.handlePlay);
    }

    handlePlay() {
        if (!Cookies.get('course-player-played')) {
            Cookies.set('course-player-played', true)
        }
    }

    handleTimeUpdate() {
        const currentTime = this.player.currentTime()
        const currentProgress = parseInt((currentTime / this.player.duration()) * 100, 10)
        const $episode = this.$episodes.filter('.playing')
        $episode.next(Selector.SERIE_EPISODE_PROGRESS).find(Selector.STATUS_BAR).attr('aria-valuenow', currentProgress).css('width', currentProgress + '%')
        $episode.data('time', currentTime)
    }

    startLesson(e) {
        const $this = $(e.target)
        Cookies.set('last-lesson-preview', $this.attr('id'))
        const config = $this.data();
        if (!config.sources) {
            return false
        }
        this.player.src(map(config.sources, (source, quality) => ({
            type: 'video/mp4',
            src: source,
            label: {hd: '720P', sd: '480P', ld: '360P'}[quality],
            selected: quality === 'sd'
        })))
        this.player.poster(config.poster || '')

        const time = $this.data('time')
        if (time) {
            this.player.currentTime(Number.parseInt(time, 10))
        }

        $('html, body').animate({
            scrollTop: $('#course-player').offset().top - 80
        })

        this.player.play()

        this.$episodes.filter('.playing').removeClass('playing').addClass('played')
        $this.removeClass('played').addClass('playing');
    }
}

videojs.registerPlugin('simple_comando', SimpleComando)

$('#course-player').each(function () {
    const player = videojs(
        'course-player',
        {
            controls: true,
            autoplay: false,
            preload: 'auto',
            language: 'it',
            inactivityTimeout: 1000,
            controlBar: {
                children: videoJsControlsBar,
                volumePanel: {inline: false}
            },
            playbackRates: [0.5, 1, 1.25, 1.5, 1.75, 2],
        },
        () => {
            videojs.log('Your player is ready!', player)
        }
    )

    player.ready(function () {
        const is_lazy = parseInt(this.options_['data-lazy'])

        if (is_lazy === 1) {
            this.src({src: this.options_['data-src'], type: this.options_['data-type']})
        }
    })

    if ($('#course').hasClass('modal')) {
        player.comando()
    } else if (!$('#course').hasClass('course-bought')) {
        player.simple_comando()
    } else {
        $('.lesson.playable').on('click', function () {
            $(location).prop('href', $(this).attr('data-url'))
        })
    }
});

$('.lesson-download').each(function () {
    var $downloader = $(this);
    $downloader.popover({
        html: true,
        trigger: 'focus',
        content: function () {
            var $this = $(this);
            if (!$this.data('content-html')) {
                var $content = $('<div class="nav nav-pills nav-fill"></div>');
                $content.append($.map($downloader.prevAll('.lesson').data('sources'), function (url, quality) {
                    return $('<a href="' + url + '" class="nav-item nav-link">' + quality.toUpperCase() + '</a>');
                }));
                $this.data('content-html', $content);
            }
            return $this.data('content-html');
        }
    });
});
